/**
 * CoordinatorEvent - Type-safe event emitter for coordinator communication
 *
 * Provides a simple event system for coordinators to emit semantic events
 * that other coordinators can listen to.
 */

export interface CoordinatorEvent<T = void> {
  addListener(callback: (data: T) => void): () => void;
  emit(data: T): void;
}

export class CoordinatorEventImpl<T = void> implements CoordinatorEvent<T> {
  private listeners: Array<(data: T) => void> = [];

  addListener(callback: (data: T) => void): () => void {
    this.listeners.push(callback);
    // Return unsubscribe function
    return () => {
      const index = this.listeners.indexOf(callback);
      if (index > -1) {
        this.listeners.splice(index, 1);
      }
    };
  }

  emit(data: T): void {
    this.listeners.forEach((listener) => {
      try {
        listener(data);
      } catch (error) {
        console.error('[CoordinatorEvent] Listener error:', error);
      }
    });
  }
}
